import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage.vue'
import MobileHomePage from '@/components/mobile/HomePage.vue'
import MobileCulture from '@/components/mobile/Culture.vue'
import Culture from '@/components/Culture.vue'
import MobileWelfare from '@/components/mobile/Welfare.vue'
import Welfare from '@/components/Welfare.vue'
import Salary from '@/components/Salary.vue'
import Guarantee from '@/components/Guarantee.vue'
import ColorfulLife from '@/components/ColorfulLife.vue'
import FamilyBenefits from '@/components/FamilyBenefits.vue'
import Advance from '@/components/Advance.vue'
import MobileAdvance from '@/components/mobile/Advance.vue'
import Positions from '@/components/Positions.vue'
import MobilePositions from '@/components/mobile/Positions.vue'
import ApplyProcess from '@/components/ApplyProcess.vue'
import MobileApplyProcess from '@/components/mobile/ApplyProcess.vue'
import JoinUs from '@/components/JoinUs.vue'
import ContactUs from '@/components/ContactUs.vue'
import MobileContactUs from '@/components/mobile/ContactUs.vue'
Vue.use(Router)
const routesPc =  [

  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  
  {
    path: '/culture',
    name: 'Culture',
    component: Culture
  },
  
  {
    path: '/welfare',
    name: 'Welfare',
    component: Welfare
  },

  
  {
    path: '/salary',
    name: 'Salary',
    component: Salary
  },
  
  {
    path: '/guarantee',
    name: 'Guarantee',
    component:Guarantee
  },
  {
    path: '/colorfulLife',
    name: 'ColorfulLife',
    component: ColorfulLife
  },
  {
    path: '/familyBenefits',
    name: 'FamilyBenefits',
    component: FamilyBenefits
  },
  {
    path: '/advance',
    name: 'Advance',
    component: Advance
  },
  {
    path: '/joinUs',
    name: 'JoinUs',
    component: JoinUs
  },
  
  {
    path: '/applyProcess',
    name: 'ApplyProcess',
    component: ApplyProcess
  },
  
  {
    path: '/positions',
    name: 'Positions',
    component: Positions
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs
  },
]

const routesMobile =  [

  {
    path: '/',
    name: 'HomePage',
    component: MobileHomePage
  },
  
  {
    path: '/culture',
    name: 'Culture',
    component: MobileCulture
  },
  
  {
    path: '/welfare',
    name: 'Welfare',
    component: MobileWelfare
  },

  {
    path: '/advance',
    name: 'Advance',
    component: MobileAdvance
  },
  {
    path: '/joinUs',
    name: 'JoinUs',
    component: JoinUs
  },
  
  {
    path: '/applyProcess',
    name: 'ApplyProcess',
    component: MobileApplyProcess
  },
  
  {
    path: '/positions',
    name: 'Positions',
    component: MobilePositions
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: MobileContactUs
  },
]

var routes = [];

if(navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)){
  routes = routesMobile
}else{
  routes = routesPc
}


export default new Router({
    routes
})



// WEBPACK FOOTER //
// ./src/router/index.js